import React from "react";
import { FlaskConical, CircleCheck, Clock } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function LabTestingVerification() {
  return <section data-section-id="255082" id="service-details" className="bg-background text-foreground light">
      <div className="bg-accent/30 py-16 md:py-24">
        <div className="page-container flex justify-center">
          <div className="flex flex-col items-center max-w-[1000px] w-full">
            
            <h2 className="text-3xl font-bold font-default text-center mb-8 text-[rgba(25,19,53,1)] md:text-4xl">
              Վերգետնյա կայանի հնարավորությունները
            </h2>
            
            <div className="font-sans text-justify text-xl font-medium text-[rgba(25,19,53,1)]">
              <p className="mb-4">
                Արբանյակային կապի համար նախատեսված վերգետնյա կայանը համալրված է բարձր արդյունավետությամբ բազմաբենդ ալեհավաքային համակարգով, որն ապահովում է աշխատանք S, X և Ka հաճախականությունների տիրույթներում։ Այս կառուցվածքը հնարավորություն է տալիս իրականացնել լայն սպեկտրի կիրառություններ՝ սկսած արբանյակային կապից մինչև խոր տիեզերական ցանցերի առաջադեմ լուծումներ։
              </p>
              <p>
                Ալեհավաքը ապահովում է բարձր ելքային հզորություն և զգայունություն, ինչը հնարավորություն է տալիս իրականացնել հուսալի կապ, ճշգրիտ հետագծում և անխափան տվյալների ներբեռնում ու փոխանցում։ Համակարգի ճկունությունն ու տեխնիկական բնութագրերը այն դարձնում են հարմարեցված գիտական հետազոտությունների, պաշտպանական ծրագրերի և առևտրային առաքելությունների համար՝ առանձնացնելով այն որպես ապագային լիովին պատրաստ և երկարաժամկետ հուսալի ենթակառուցվածք։
              </p>
            </div>

          </div>
        </div>
      </div>
    </section>;
}